// TODO: this file is duplicated between both the RN and web repos

export default {
  APP_NAME: 'farmx-admin',
  VERSION: '0.1',
  API_URL: "https://map.farmx.co", //"http://localhost:8000", 
  ADMIN_URL: "https://map.farmx.co/admin",
  DEFAULT_HEADERS: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  SENSOR_TYPES: {
    'farmx_dendrometer': {
      name: "Dendrometer",
      shortName: "DD",
    },
    'weather_station': {
      name: "Weather Station",
      shortName: "WS",
    },
    'gateway': {
      name: "Gateway",
      shortName: "BD",
    },
    'pixl_soil': {
      name: "Pixl Soil",
      shortName: "PX",
    },
    'water_pressure': {
      name: "Pressure",
      shortName: "PR",
    },
    'aquacheck_soil': {
      name: "AquaCheck Soil",
      shortName: "AQ",
    },
    'water_flow': {
      name: "Flowmeter",
      shortName: "FM",
    },
    'water_flow_analog': {
      name: "Flowmeter (mesh)",
      shortName: "FMX",
    },
    'vfd': {
      name: "VFD",
      shortName: "VFD",
    },
    'farmx_frost': {
      name: "Frost",
      shortName: "FR",
    },
    'farmx_infrared': {
      name: "Infrared",
      shortName: "IF",
    },
    'boxer_soil': {
      name: "Boxer Soil",
      shortName: "BX",
    },
    'boxer_station': {
      name: "Base Station",
      shortName: "BS",
    },
    'cavalier': {
      name: "Cavalier",
      shortName: "CAV",
    },
    'valve': {
      name: "Valve",
      shortName: "VL",
    },
  }
};
